<template>
  <main>
    <div class="logout-wrapper">
      <f-button type="secondary" @click="handleLogout">تسجيل الخروج</f-button>
    </div>
    <div class="base_div">
      <div class="content">
        <section class="green_logo_section">
          <img src="@/assets/Image/greenLogo.png" alt="logo" />
        </section>
        <section class="data_section">
          <p>
            نظام ذكي لمساعدة نقاط التفتيش في فحص شهادات الشاحنات بسهولة ودقة
          </p>
          <router-link to="/qr-reader">البدأ بمسح المعلومات</router-link>
        </section>
        <section class="footer_section">
          <img src="@/assets/Image/Layer_1.png" alt="" />
        </section>
      </div>
      <div class="image">
        <span></span>
        <img src="@/assets/Image/truck.png" alt="bg_truck" />
      </div>
    </div>
  </main>
</template>

<script>
import { logout } from "@/Utils/logout";

export default {
  methods: {
    handleLogout() {
      logout(this.$router);
    },
  },
};
</script>

<style scoped>
.logout-wrapper {
  position: fixed;
  top: 24px;
  right: 24px;
  z-index: 100;
}

.logout-wrapper :deep(.btn) {
  width: auto;
  padding: 10px 20px;
}

main {
  width: 100%;
  height: 100vh;
  display: flex;
  overflow-x: none;
}

.base_div {
  position: relative;
  width: 100%;
}

.image {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: calc(100% + 180px) calc(100%);
}

.image span {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    179.6deg,
    rgba(255, 255, 255, 0) 8.08%,
    rgba(219, 222, 243, 0.06) 32.1%,
    rgba(210, 217, 236, 0.0878021) 38.43%,
    rgba(76, 127, 114, 0.515479) 58.77%,
    rgba(0, 76, 44, 0.76) 103.51%
  );
}

.content {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  gap: 20px;
}

.content .green_logo_section {
  margin-top: 75px;
}

.content .data_section {
  width: 80%;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 15px;
  color: var(--white);
  position: absolute;
  bottom: 80px;
  align-items: center;
}

.data_section p {
  font-weight: 600;
  font-size: 18px;
  text-align: center;
}

.data_section a{
  text-decoration: none;
  background-color: var(--white);
  color: var(--primary-color);
  padding: 20px;
  width: 250px;
  text-align: center;
  font-weight: 600;
  border-radius: 10px;
}

.data_section a:hover{
  background-color: var(--primary-color);
  color: var(--white);
  transition: all 0.3s ease-in-out;
}

.footer_section{
  width: 100%;
  text-align: center;
}

.footer_section img {
  width: 200px;
  height: 40px;
  object-position: center;
}
</style>